const FindInPage =require('./findInPage')
const Find = require('./find.js')


module.exports = {
  FindInPage,
  Find
}